export enum AuthMode {
  Signup,
  Signin,
}

export type GoogleButtonLayout =
  | 'default'
  | 'signup-desktop'
  | 'mobile-stacked'
  | 'signup-popup'
